import { render, staticRenderFns } from "./TopSection.vue?vue&type=template&id=66b1b18e&scoped=true"
import script from "./TopSection.vue?vue&type=script&lang=js"
export * from "./TopSection.vue?vue&type=script&lang=js"
import style0 from "./TopSection.vue?vue&type=style&index=0&id=66b1b18e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b1b18e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BackButton: require('/builds/docue/website/components/BackButton.vue').default,SolidPlayIcon: require('/builds/docue/website/node_modules/@nuxt-hero-icons/solid/src/components/PlayIcon.vue').default,CustomLink: require('/builds/docue/website/components/CustomLink.vue').default,DTButton: require('/builds/docue/website/node_modules/@docue/docue-ui/src/components/DTButton/DTButton.vue').default,OutlineChevronRightIcon: require('/builds/docue/website/node_modules/@nuxt-hero-icons/outline/src/components/ChevronRightIcon.vue').default,IconCheckCircleBroken: require('/builds/docue/website/components/Icon/IconCheckCircleBroken.vue').default})
